import { Component } from 'react';
import { TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import { HorizontalAlignment, VerticalAlignment } from '@optimus-web/core';

interface AlertHolderProps {
    alerts: JSX.Element[];
    horizontalPosition: HorizontalAlignment;
    verticalPosition: VerticalAlignment;
    innerRef?: React.Ref<HTMLDivElement>;
}
class AlertHolder extends Component<AlertHolderProps> {
    render() {
        const { alerts, verticalPosition, horizontalPosition } = this.props;
        const verticalPositionClass = `position-${verticalPosition}`;
        const horizontalPositionClass = `position-${horizontalPosition}`;
        const css = {
            'alert-holder-wrapper': true,
            [verticalPositionClass]: true,
            [horizontalPositionClass]: true,
        };
        return (
            <div className={classNames(css)} ref={this.props.innerRef}>
                <TransitionGroup>{alerts}</TransitionGroup>
            </div>
        );
    }
}

export default AlertHolder;
